module.exports = __webpack_public_path__ + "img/5dca87323d924e23e5dedae49e8655db.svg";